module.exports = __webpack_public_path__ + "img/proses_sti_sc.6ae4b689.svg";